import * as Sentry from "@sentry/react";

const env = import.meta.env as Record<string, string | undefined>;
const dsn = env.VITE_SENTRY_DSN;

/** Starts the browser Sentry client. Takes the router so navigations become transactions. */
export function initSentry(
  router: Parameters<typeof Sentry.tanstackRouterBrowserTracingIntegration>[0],
) {
  Sentry.init({
    dsn,
    environment: env.VITE_SENTRY_ENVIRONMENT,
    release: env.VITE_SENTRY_RELEASE,
    // No DSN means no client at all, which is the local and no-Sentry-stage case.
    enabled: Boolean(dsn),
    enableLogs: true,
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    // The SPA calls only the same-origin BFF; the leading (?!\/) keeps out //other-host paths.
    tracePropagationTargets: [/^\/(?!\/)/],
    // Termly's own runtime errors are Termly's, not the storefront's.
    denyUrls: [
      /^chrome-extension:\/\//,
      /^moz-extension:\/\//,
      /^safari(-web)?-extension:\/\//,
      /^https:\/\/app\.termly\.io\//,
    ],
    ignoreErrors: [
      "Load failed",
      "Failed to fetch",
      "NetworkError when attempting to fetch resource.",
    ],
  });
}
